export const nameMap = {
  iconMbs1Vertical: 'icon-mbs icon-mbs--1 icon-mbs--vertical',
  iconMbs2Vertical: 'icon-mbs icon-mbs--2 icon-mbs--vertical',
  iconMbs3Vertical: 'icon-mbs icon-mbs--3 icon-mbs--vertical',
  iconMbs4Vertical: 'icon-mbs icon-mbs--4 icon-mbs--vertical',
  iconMbs5Vertical: 'icon-mbs icon-mbs--5 icon-mbs--vertical',
  iconMbs1Horizontal: 'icon-mbs icon-mbs--1 icon-mbs--horizontal',
  iconMbs2Horizontal: 'icon-mbs icon-mbs--2 icon-mbs--horizontal',
  iconMbs3Horizontal: 'icon-mbs icon-mbs--3 icon-mbs--horizontal',
  iconMbs4Horizontal: 'icon-mbs icon-mbs--4 icon-mbs--horizontal',
  iconMbs5Horizontal: 'icon-mbs icon-mbs--5 icon-mbs--horizontal',
  iconMbsLiveHorizontalRed: 'icon-mbs icon-mbs--live icon-mbs--horizontal icon-mbs--horizontal--red',
  iconMbs1: 'icon-mbs icon-mbs--1',
  iconMbs2: 'icon-mbs icon-mbs--2',
  iconMbs3: 'icon-mbs icon-mbs--3',
  iconMbs4: 'icon-mbs icon-mbs--4',
  iconMbs5: 'icon-mbs icon-mbs--5',
  iconMbs1Betslip: 'icon-mbs icon-mbs--1 icon-mbs--betslip',
  iconMbs2Betslip: 'icon-mbs icon-mbs--2 icon-mbs--betslip',
  iconMbs3Betslip: 'icon-mbs icon-mbs--3 icon-mbs--betslip',
  iconMbs4Betslip: 'icon-mbs icon-mbs--4 icon-mbs--betslip',
  iconMbs5Betslip: 'icon-mbs icon-mbs--5 icon-mbs--betslip',
  iconBanko: 'icon-banko',
  iconBankoActive: 'icon-banko icon-banko--active',
  iconTeamFormStatusWon: 'icon-team-form-status icon-team-form-status--won',
  iconTeamFormStatusLost: 'icon-team-form-status icon-team-form-status--lost',
  iconTeamFormStatusDraw: 'icon-team-form-status icon-team-form-status--draw',
  svgActionThreeDots: 'ic_action_three_dots',
  svgAddAccount: 'ic_add_account',
  svgEditAccount: 'ic_edit_account',
  svgEyeClose: 'ic_eye_close',
  svgEyeOpen: 'ic_eye_open',
  svgAccordionClose: 'ic_close_accordion',
  svgAccordionOpen: 'ic_open_accordion',
  svgAccordionCloseGray: 'ic_close_accordionGray',
  svgAccordionOpenGray: 'ic_open_accordionGray',
  svgAccordionCloseColored: 'ic_close_accordion_colored',
  svgAccordionOpenColored: 'ic_open_accordion_colored',
  svgBack: 'ic_back',
  svgBellWhite: 'ic_bell_white',
  svgBetUp: 'ic_bet_up',
  svgBilyoner: 'ic_bilyoner',
  svgBilyonerGanyan: 'ic_bilyonerganyan',
  svgBilyonerCircle: 'ic_bilyoner_logo_circle',
  svgBilyonerTv: 'ic_bilyonertv',
  svgBilyonerTvV2: 'ic-bilyonertv-v2',
  svgStar: 'ic_star',
  svgCalendar: 'ic_calendar',
  svgCaretUpGreen: 'ic_caret_up_green',
  svgCaretDownRed: 'ic_caret_down_red',
  svgChangePlayer: 'ic_change_player',
  svgCheckGreen: 'ic_check_green',
  svgCheckWhite: 'ic_check_white',
  svgCloseGray: 'ic_close_gray',
  svgCloseDelete: 'ic_close_delete',
  svgCloseDeleteLightGreen: 'ic_close_delete_light_green',
  svgCloseDeleteWhite: 'ic_close_delete_white',
  svgClose: 'ic_close',
  svgCloseWhite: 'ic_close_white',
  svgComments: 'ic_comments',
  svgCommentAuthor: 'ic_comment_author',
  svgAuthorFilter: 'ic_author_filter',
  svgAuthorFilterActive: 'ic_filter_active',
  svgSendComment: 'ic_send_comment',
  svgCloseComment: 'ic_close_comment',
  svgOpenComment: 'ic_open_comment',
  svgCommentGreen: 'ic_comment_green',
  svgCouponDetail: 'ic_coupon_detail',
  svgCopy: 'ic_copy',
  svgCopyWhite: 'ic_copy_white',
  svgPin: 'ic_pin',
  svgPinDark: 'ic_pin_dark',
  svgDirector: 'ic_director',
  svgDown: 'ic_down',
  svgDownArrow: 'ic_down_arrow',
  svgDownArrowRaffle: 'ic_down_arrow_raffle',
  svgDownArrowWhite: 'ic-arrow-up-white',
  svgStarEmpty: 'ic_empty_star',
  svgFilterTransparanDark: 'ic_filter_transparan_dark',
  svgFirstUser: 'ic_first_user',
  svgSecondUser: 'ic_second_user',
  svgThirthUser: 'ic_thirth_user',
  svgFollowNotif: 'ic_follow_notif',
  svgFollowingUser: 'ic_following_user',
  svgHamburgerWhite: 'ic_hamburger_white',
  svgPassHide: 'ic-hide-pass',
  svgIm: 'ic_im',
  svgReadAnnouncementsOpen: 'ic_read_announcements',
  svgReadAnnouncementsClose: 'ic_read_announcements_close',
  svgImportantBullhorn: 'ic_important_bullhorn',
  svgBullhornGreen: 'ic_bullhorn_green',
  svgInfo: 'ic_info',
  svgInfoWhite: 'ic_info_white',
  svgInfoYellow: 'ic_info_yellow',
  svgInfoGray: 'ic_info_gray',
  svgInfoLightWhite: 'ic_info_light_white',
  svgInjury: 'ic_injury',
  svgLikeEmpty: 'ic_like_empty',
  svgLikeFill: 'ic_like_fill',
  svgLike: 'ic_like',
  svgMessages: 'ic_messages',
  svgMembership: 'ic_membership',
  svgMP: 'ic_milli_piyango',
  svgMissPenalty: 'ic_miss_penalty',
  svgMPCoupon: 'ic_mp_my_coupon',
  svgMPResult: 'ic_mp_result',
  svgBalanceWallet: 'ic_mybalance_wallet',
  svgPlay: 'ic_play',
  svgPlayFailure: 'ic_play_failure',
  svgPunishment2: 'ic_punishment_2',
  svgPunishmentRed: 'ic_punishment_red',
  svgPunishmentYellow: 'ic_punishment_yellow',
  svgRefresh: 'ic_refresh',
  svgReportGreen: 'ic_report_green',
  svgArrowRight: 'ic_right_arrow',
  svgArrowRightWhite: 'ic_right_arrow_white',
  svgArrowRightTheme: 'ic_right_arrow_theme',
  svgSantra: 'ic_santra',
  svgSave: 'ic_save',
  svgSearch: 'ic_search',
  svgShare: 'ic_share',
  svgPassShow: 'ic-show-pass',
  svgSoccer: 'ic_soccer',
  svgArrowDownSolid: 'ic_solid_down_arrow',
  svgArrowDownSolidWhite: 'ic_solid_down_arrow_white',
  svgSort2: 'ic_sort2',
  svgSortDark: 'ic_sort_dark',
  svgSortNew: 'ic_sort_new',
  svgSportotoGrey: 'ic_spor_toto_grey',
  svgSportotoCouponEdit: 'ic_spor_toto_coupon_edit',
  svgSportotoCancel: 'ic_spor_toto_delete',
  svgSportotoWinner: 'ic_spor_toto_winner',
  svgSportotoTransfer: 'ic_spor_toto_transfer',
  svgStatsWhite: 'ic_stats-white',
  svgTicketLose: 'ic_ticket_lose',
  svgTicketWin: 'ic_ticket_win',
  svgTicketWinAuthor: 'ic_ticket_win_author',
  svgNotLoginWinLose: 'ic_not_login_winlost',
  svgTime: 'ic_time',
  svgTrash: 'ic_trash',
  svgTrashGrey: 'ic_trash_grey',
  svgTrashWhite: 'ic_trash_white',
  svgTrashRed: 'ic_trash_red',
  svgTrashGreyIcon: 'ic_trash_grey_back_match',
  svgTrashDisabled: 'ic_trash_disabled',
  svgTrashOrange: 'ic_trash_orange',
  svgTrashDarkGrey: 'ic_trash_dark_grey',
  svgTribun2: 'ic_tribun_2',
  svgTribun: 'ic_tribun',
  svgTribunWhite: 'ic_tribun_white',
  svgTribunOrange: 'ic_tribun_orange',
  svgTribunGreen: 'ic_tribun_green',
  svgTv: 'ic_tv',
  svgTv2: 'ic_tv2',
  svgUniform: 'ic_uniform',
  svgSubstitutes: 'ic_substitutes',
  svgPlayerOnSubs: 'ic_player_on',
  svgPlayerOffSubs: 'ic_player_off',
  svgArrowUp: 'ic_up_arrow',
  svgWarning: 'ic_warning',
  svgWarningCurrent: 'ic_warning_current',
  svgWarningWhite: 'ic_warning_white',
  svgWarningYellow: 'ic_warning_yellow',
  svgWeatherSnowly: 'ic_weathers_snowly',
  svgWeatherSunny: 'ic_weathers_sunny',
  svgWhistle: 'ic_whistle',
  svgQuestion: 'ic_questions',
  svgBetDown: 'ic_bet_down',
  svgYellowToRed: 'yellow_to_red',
  svgIosAppStore: 'ic_app_store',
  svgHuaweiGallery: 'ic_huawei_gallery',
  svgGalaxyStore: 'ic_galaxy_store',
  svgSettingsWheel: 'ic_settings_wheel',
  svgSporTotoRandom: 'ic_spor_toto_random',
  svgVideoFullScreen: 'ic-full-screen',
  svgVideoPlayV2: 'ic-play-v2',
  svgVideoPauseV2: 'ic-pause-v2',
  svgBackWhite: 'ic_back_white',
  svgPlus: 'ic_plus',
  svgGreenPlus: 'ic_green-plus',
  svgMinus: 'ic_minus',
  svgArrowUpBlack: 'ic-up-icon',
  svgAlertTriangle: 'ic_alert_triangle',
  svgCallCustomerService: 'ic_call_customer_service',
  svgUv2: 'ic_uv2',
  svgIddaaLittleFinger: 'ic_iddaa_little_finger',
  svgInfoGrey: 'ic_info_grey',
  svgInfoTheme: 'ic_info_theme',
  svgInfoDarkGrey: 'ic_info_darkgrey',
  svgInfoLightGray: 'ic_info_lightgray',
  svgInfoGreen: 'ic_info_green',
  svgInfoMainGreen: 'ic_info_main_green',
  svgInfoRed: 'ic_info_red',
  svgGenaralWarning: 'general_warning',
  svgWaiting: 'ic-combined-shape',
  svgHourglassOrange: 'ic_hourglass_orange',
  svgNavCoupons: 'ic_nav_coupons',
  svgAge18: '18_yas',
  svgIconSettings: 'ic-betslip-settings',
  svgStatusWin: 'status_win',
  svgStatusLose: 'status_lose',
  svgIddaaLogo: 'iddaaa_logo',
  svgSporToto: 'spor_toto',
  svgFavoriteFilled: 'ic_star_favorited',
  svgFavoriteDarkGreenFilled: 'ic_star_favorited_dark_green',
  svgGift: 'ic-gift-catalog',
  svgBirthday: 'ic-birthday',
  svgModalFail: 'modal-fail',
  svgModalSuccess: 'modal-success',
  svgIconWaiting: 'ic-waiting',
  svgIconFailed: 'ic-failed',
  svgIconSuccess: 'ic-success',
  svgIconSuccessNoti: 'ic-success-noti',
  svgIconDown: 'ic-down',
  svgNewPlus: 'ic_new_plus',
  svgNewLeaderboard: 'ic_large_liderler',
  svgSystemCoupon: 'ic_system_coupon',
  svgPhoto: 'ic_photo',
  svgUp: 'ic_up',
  svgUploadPhoto: 'ic_photo-icon',
  svgHeart: 'ic_heart',
  svgHeartEmpty: 'ic_heart_empty',
  svgButtonWon: 'ic_button_won',
  svgButtonLost: 'ic_button_lost',
  svgHide: 'ic_hide',
  svgHideDark: 'ic_hide_dark',
  svgShow: 'ic_show',
  svgShowDark: 'ic_show_dark',
  svgSetting: 'ic_setting',
  svgCircleCheck: 'ic_check_circle',
  svgTribunShare: 'ic_tribun_share',
  svgPopularBets: 'ic_popular_bets',
  svgPopulerSporToto: 'ic_sportoto_popular',
  svgLinkCopied: 'ic_link_copied',
  svgCircleTwitter: 'ic_circle-twitter',
  svgCircleFacebook: 'ic_circle-facebook',
  svgCircleWhatsapp: 'ic_circle-whatsapp',
  svgFacebook2: 'ic_facebook2',
  svgWhatsapp2: 'ic_whatsapp2',
  svgTwitter2: 'ic_twitter2',
  svgUrl2: 'ic_url',
  svgIcWon: 'ic_won-icon',
  svgIcLost: 'ic_lost-icon',
  svgChanceGamesRefresh: 'ic_chance_games_refresh',
  svgHandOkeyIcon: 'hand-okey-icon',
  svgChanceGamesPlayAgainButton: 'ic_chance_games_play-again',
  svgBetsChangesStackCircle: 'ic_bets_changes_stack_circle',
  svgCommentStackCircle: 'ic_comment_stack_circle',
  svgLiveStackCircle: 'ic_live_stack_circle',
  svgTvStackCircle: 'ic_tv_stack_circle',
  svgWatchStackCircle: 'ic_watch_stack_circle',
  svgWatchStackCircleFilledWithText: 'ic_watch_stack_circle_filled_with_text',
  svgRapidMarketCircle: 'ic_rapid_market_circle',
  svgRenovation: 'renovation',
  svgPartyPopper: 'ic_party_popper',
  svgQrCodeAndroid: 'qr-android',
  svgQrCodeApple: 'qr-apple',
  svgQrCodeGalaxy: 'qr-galaxy',
  svgQrCodeHuawei: 'qr-huawei',
  svgTVCircle: 'ic-tv-circle',
  svgTVCircleGreen: 'ic-tv-circle-green',
  svgTVCircleWhite: 'ic-tv-circle-white',
  svgPlayCircleGrey: 'ic-fil-tv-light-grey',
  svgPlayerAnalyzV2: 'ic-player-analyz-v2',
  svgPlayCircleGreen: 'ic-fil-tv-light-green',
  svgPlayCircleWhite: 'ic-fil-tv-light-white',
  svgStatisticsOn: 'ic-statistics-on',
  svgStatisticsOff: 'ic-statistics-off',
  svgDrawing: 'ic_ticket_refund',
  svgHorseRacing: 'ic_horse_race',
  svgHorseWhite: 'ic_horse_white',
  svgNextgenHorseRace: 'ic-next-nextgen-home-horse-race',
  svgHelp: 'ic_help',
  svgVideo: 'ic_video',
  svgImage: 'ic_image',
  svgBetslipHorse: 'ic_betslip_horse',
  svgJockeyStar: 'ic_jockey_star',
  svgShareWhite: 'ic_share_white',
  svgShareBlack: 'ic_share_black',
  svgSocialShareLink: 'ic_social_share_link',
  svgSocialShareX: 'ic_social_share_x',
  svgSocialShareFacebook: 'ic_social_share_facebook',
  svgSocialShareWhatsapp: 'ic_social_share_whatsapp',
  svgTjkWin: 'ic_tjk_win',
  svgTjkLose: 'ic_tjk_lose',
  svgEkuriHorse: 'ic_ekuri_horse',
  svgAuthor: 'ic_author_icon',
  svgPreBulletinLive: 'ic_pre_bulletin_live_red',
  svgRenameCoupon: 'ic_rename_coupon',
  svgHeaderLeft: 'ic_header_left',
  svgHeaderRight: 'ic_header_right',
  svgChanceGames: 'ic_chance_games',
  svgGreenDownArrow: 'ic_green_arrow_down',
  svgGreenUpArrow: 'ic_green_arrow_up',
  svgArrowRightGray: 'ic_arrow_right_gray',
  svgArrowRightGreen: 'ic_arrow_right_green',
  svgArrowRightDarkGreen: 'ic_arrow_right_dark_green',
  svgArrowRightDarkGray: 'ic_arrow_right_dark_gray',
  svgRafflePrize: 'ic_raffle_prize',
  svgRaffleArrowDown: 'ic_raffle_arrow_down',
  svgRaffleArrowUp: 'ic_raffle_arrow_up',
  svgGreenInfo: 'ic_green_info',
  svgNonHighlight: 'ic_non_highlight',
  svgHighlightTabActive: 'ic_highlight_tab_active',
  svgHiglightGreen: 'ic_highlight_green',
  svgGameArrowRight: 'ic-game-arrow-right',
  svgGameArrowRightWhite: 'ic-game-arrow-right-white',
  svgGameArrowRightwtext: 'ic-game-arrow-rightwtext',
  svgInfoLight: 'icon-info-light',
  svgWaitingSmall: 'ic_waiting_small',
  svgWaitingBig: 'ic_waiting',
  svgWaitingOrange: 'ic_waiting_orange',
  svgInfoLightBlack: 'icon-info-light-black',
  svgCopyBlack: 'ic_copy_black',
  svgClearFilter: 'ic_clear_filter',
  svgNavIddaaFinger: 'ic_nav_iddaa_finger',
  svgNavTribune: 'ic_nav_tribun',
  svgNavSporToto: 'ic_nav_sportoto',
  svgNavScore: 'ic_nav_score',
  svgNavFire: 'ic_nav_fire',
  svgNavAuthors: 'ic_nav_authors',
  svgNavChanceGames: 'ic_menu_chance_games',
  svgNavScratchCard: 'ic_menu_scratch_card',
  svgHelpWhite: 'ic_help_white',
  svgResponsibleGambling: 'ic_responsible_gambling',
  svgResponsibleGamblingMobile: 'ic_responsible_gambling_mobile',
  svgResponsibleGamingMenu: 'ic_responsible_gaming_menu',
  svgSync: 'ic_header_sync',
  svgLogout: 'ic_account_logout',
  svgCopyHeader: 'ic_copy_header',
  svgBellSelected: 'ic_bell_selected',
  svgBellUnselected: 'ic_bell_unselected',
  svgBellSelectedWhite: 'ic_bell_selected_white',
  svgBellUnselectedWhite: 'ic_bell_unselected_white',
  svgBlockUser: 'ic_block_user',
  svgUnblockUser: 'ic_unblock_user',
  svgClockScheduleTime: 'ic_clock_schedule_time',
  svgGreenEdit: 'ic_green-edit',
  svgInfoBlack: 'ic_info_black',
  svgArrowDownBlack: 'ic_arrow_down_black',
  svgArrowDownGray: 'ic_arrow_down_gray',
  svgDragDrop: 'ic-drag-drop',
  svgDragDropRed: 'ic-drag-drop-red',
  svgCloseGraySolid: 'ic-close-gray-solid',
  svgAuthorsUp: 'ic_authors_up',
  svgAuthorsDown: 'ic_authors_down',
  svgDecrease: 'ic-decrease',
  svgIncrease: 'ic-increase',
  svgLargeUzay: 'icons-large-uzay',
  svgNormalQuestionMark: 'ic_normal_questionmark',
  svgThumpsUp: 'ic-thumbs-up',
  svgAlert: 'ic-alert',
  svgAlertError: 'ic_alert_error',
  svgCloseBlack: 'ic-close',
  svgChevronRight: 'ic_chevron_right',
  svgChevronRightCurrent: 'ic_chevron_right_current',
  svgLiveStream: 'ic_live_stream',
  svgInformationCircle: 'ic_information_circle',
  svgMoonWhite: 'ic_moon_white',
  svgSunWhite: 'ic_sun_white',
  svgMoon: 'ic_moon',
  svgSun: 'ic_sun',
  svgInfoCircleGreen: 'ic_info_circle_green',
  svgNavMultipleMatch: 'ic_nav_multiple_match',
  svgLeftArrow: 'ic_arrow_left',
  svgRightArrow: 'ic_arrow_right',
  svgLeftArrowWhite: 'ic_left_arrow_white',
  svgLmtPin: 'ic_lmt_pin',
  svgQr: 'ic_qr',
  svgQuestionMark: 'ic_question_mark',
  svgQuestionMarkBlack: 'ic_question_mark_black',
  svgInfoExclam: 'ic_info_exclam',
  svgCanliZirveBadge: 'canli_zirve_badge',
  svgZirveOran: 'zirve_oran',
  svgInfoWarningBlack: 'ic_info_warning_black',
  svgInfoWarningWhite: 'ic_info_warning_white',
  svgCloseCircleBlack: 'ic_close_circle_black',
  svgArrowDownTribune: 'ic_arrow_down',
  svgArrowUpTribune: 'ic_arrow_up',
  svgInfoPopularOrange: 'ic_info_orange',
  svgInfoDarkWhite: 'ic_info_dark_white',
  svgInfoDark: 'ic_info_dark',
  svgLiveScoreNew: 'ic_live_score_new',
  svgLive: 'ic_live',
  svgNavWatchGreen: 'ic_nav_watch_green',
  svgCampaignsGreenNew: 'ic_campaigns_green_new',
  svgMacKartiXg: 'xg-mac-karti',
  svgNavVirtualGames: 'ic_menu_virtual_bet',
  svgBackIcon: 'ic_back_icon',
  svgBLogo: 'ic_b_logo',
  svgSmartBannerBilyonerIcon: 'ic_smartbanner_bilyoner_icon',
  svgArrowToUp: 'arrow_up',
  svgArrowToDown: 'arrow_down',
  svgGuideIcon: 'guide-icon',
  svgHamburgerClose: 'hm_close',
  svgHamburgerMenu: 'hm_open',
  svgMenuHorse: 'ic_menu_horse',
  svgMenuFixed: 'ic_menu_fixed',
  svgMenuResults: 'ic_menu_results',
  svgMenuAuthors: 'ic_menu_authors',
  svgMenuTv: 'ic_menu_tv',
  svgMenuAgf: 'ic_menu_agf',
  svgMenuUpcoming: 'ic_menu_upcoming',
  svgMenuReportedSuspended: 'ic_menu_reported_suspended',
  svgSubMenuArrow: 'ic_sub_menu_arrow',
  svgTjkTV: 'ic_tjk_tv',
  svgLock: 'ic_lock',
  svgStopWatch: 'ic_stop_watch',
  svgNoCoupon: 'ic_no_coupon',
  svgOddDown: 'ic_odd_down',
  svgOddUp: 'ic_odd_up',
  svgQuestionGreen: 'ic_question_green',
  svgKO: 'ic_ko',
  svgCheckMark: 'ic_checkmark',
  svgMegafoneCircle: 'ic_megafone',
  svgCloseRed: 'ic_close_red',
  svgDisallow: 'ic_disallowed',
  svgDoubleArrow: 'ic_double_arrow',
  svgFinishFlag: 'ic_finish_flag',
  svgFinishFlagGreen: 'ic_finish_flag_green',
  svgPredictaArrow: 'predicta-right-arrow',
  svgPredictaModalArrow: 'predicta-modal-right-arrow',
  svgSuccessPageShare: 'ic_success_page_share',
  svgSuccessPageSuccess: 'ic_success_page_success',
  svgDownDirection: 'ic_down_direction',
  svgUpDirection: 'ic_up_direction',
  svgCouponOrder: 'ic_coupon_order',
  svgChronometer: 'ic_chronometer',
  svgSliderNext: 'ic_slider_next',
  svgMp: 'ic_mp',
  svgNavbarTickets: 'ic_navbar_tickets',
  svgNavMP: 'ic_nav_mp',
  svgVaixSearch: 'ic-vaix-search',
  svgVSAfterSearchRelatedSportAll: 'ic-vs-after-search-all',
  svgVSAfterSearchRelatedSportAllBlack: 'ic-vs-after-search-all-black',
  svgVSCloseButton: 'ic-vaix-search-close-btn',
  svgVSEmptyRightArrow: 'ic-vs-empty-arrow',
  svgScratchCard: 'ic_scratch_card',
  svgVirtualBet: 'ic_virtual_bet',
  svgDepositMoney: 'ic_deposit_money',
  svgFire: 'ic_fire',
  svgTimeStatus: 'ic_time_status',
  svgMutedUser: 'ic_muted_user',
  svgFastDepositSendPayment: 'ic_fast_deposit_send_payment',
  svgFastDepositClose: 'ic_fast_deposit_close',
  svgFastDepositIbanClose: 'ic_fast_deposit_iban_close',
  svgFastDepositInfo: 'ic_fast_deposit_info',
  svgFastDepositCancelError: 'ic_fast_deposit_cancel_error',
  svgFastDepositCancelErrorDark: 'ic_fast_deposit_cancel_error_dark',
  svgFastDepositCancelInfo: 'ic_fast_deposit_cancel_info',
  svgInsufficientFunds: 'ic_insufficient_funds',
  svgAnindaBilyoner: 'ic_aninda_bilyoner',
  svgAnindaParaYatirVideo: 'ic_aninda_para_yatir_video',
  svgCheckMainGreen: 'ic_check_main_green',
  svgErrorModal: 'ic_error_modal',
  svgConfirmCheckGreen: 'ic_confirm_check_green',
  svgFilterV2: 'ic_filter_v2',
  svgSearchV2: 'ic_new_bulletin_search',
  svgSearchDropPanelV2: 'ic_large_search_input',
  svgListFilterReturn: 'ic_return_gray_bg_gray',
  svgFootballPitch: 'ic_football-pitch',
  svgPeriod: 'ic_period',
  svgPlayV2: 'ic_play-v2',
  svgStatsCorner: 'icon_stats_corner',
  svgStatsYellowCard: 'icon_stats_yellow_card',
  svgStatsRedCard: 'icon_stats_red_card',
  svgStatsXg: 'icon_stats_xg',
  svgStatsShotOnTarget: 'icon_stats_shot_on_target',
  svgStatsTotalShot: 'icon_stats_total_shot',
  svgStatsPossession: 'icon_stats_possession',
  svgStatsShrinkCards: 'icon_stats_shrink_cards',
  svgPinActive: 'icon_pin_active',
  svgPinPassive: 'icon_pin_passive',
  svgStarActive: 'icon_star_active',
  svgStarPassive: 'icon_star_passive',
  svgBackButtonV2: 'ic_back_button_v2',
  svgTvInfoV2: 'ic_tv_info_v2',
  svgArrowDownWhiteV2: 'ic_arrow_down_white_v2',
  // V2 MBS Icons
  iconMbs1V2: 'icon-mbsV2 icon-mbsV2--1',
  iconMbs2V2: 'icon-mbsV2 icon-mbsV2--2',
  iconMbs3V2: 'icon-mbsV2 icon-mbsV2--3',
  iconMbs4V2: 'icon-mbsV2 icon-mbsV2--4',
  iconMbs5V2: 'icon-mbsV2 icon-mbsV2--5',
  svgMatchCardSearchV2: 'ic_match_card_search',
  svgBetsChangesStackCircleV2: 'ic_bets_changes_stack_circleV2',
  svgInfoOutlineV2: 'ic_info_outline_v2',
  svgPercentV2: 'ic-filter-percentage-v2',
  svgModalCloseX: 'ic_modal_close_x',
  svgOddChange: 'ic_odd_change',
  svgOddRateChangeArrowUp: 'ic_odd_rate_change_arrow_up',
  svgOddRateChangeArrowDown: 'ic_odd_rate_change_arrow_down',
  svgCircleCloseGrayV2: 'ic-circle-close-gray-v2',
  svgAttentionOrange: 'ic_attention_orange',
  svgMuteUserHidden: 'ic_mute_user_hidden',
  svgUnfollowUser: 'ic_unfollow_user',
  svgGamesSearch: 'ic_games_search',
  svgGameSearchClear: 'ic_game_search_clear',
  svgGameNotFound: 'ic_not_found',
  svgGameInfo: 'ic_game_info',
  svgCloseDark: 'ic_close_dark',
  svgMobileGameSearch: 'ic_mobile_game_search',
  svgCloseCircleDark: 'ic_close_circle_dark',
  svgNavbarLive: 'ic_navbar_live',
  svgArrowRightDark: 'ic_arrow_right_dark',
  svgArrowDownWhite: 'ic_arrow_down_white',
  svgNoGames: 'ic_game_not_found',
  svgGameSelected: 'ic_game_selected_thick',
  svgTicketFilterDown: 'ic_ticket_filter_down',
  svgTicketFilterCheck: 'ic_filter_check',
  svgNewBannerZirveOranBadge: 'zirve-oran-new-banner-badge',
  svgArrowUpDark: 'ic_arrow_up_dark',
  svgCopyNew: 'ic_copy_new',
  svgDefaultBilyonerLogo: 'ic_default_bilyoner_logo',
  svgWarningExclamation: 'ic_warning_exclamation',
  svgInfoExclamation: 'ic_info_exclamation',
  svgPhone: 'ic_phone',
  svgInfoModal: 'ic_info_modal_new',
  svgNonWithDrawableAmount: 'ic_nonwithdrawable_balance',
  svgWithDrawableAmount: 'ic_withdrawable_balance',
  svgCheckFilled: 'ic_check_filled',
  svgTrashDarkRed: 'ic_trash_dark_red',
  svgConfirmError: 'ic_confirm_error',
  svgAgNav: 'ic_ag_nav',
  svgLogoWhite: 'ic_logo_white',
  svgShoe: 'ic_shoe',
  svgSaveDark: 'ic_save_dark',
  svgFooterMP: 'ic_mp_footer',
  svgVirtualHorseRace: 'ic_virtual_horse_race',
  svgInteractiveGame: 'ic_interactive_game',
  svgUnitedRacing: 'ic_united_racing',
  svgPlayCircle: 'ic_play_circle',
  svgLiveIcon: 'ic_live_icon',
  svgFilterRatioV2: 'ic-ratio-white',
  svgFilterAuthorCommentsV2: 'ic-fil-author-comments-light-grey',
  svgInfoGreyCircle: 'ic_info_circle_grey',
  svgChevronDown: 'ic_chevron_down',
  svgMenuInteractiveGame: 'ic_menu_interactive_game',
  //filter-header
  svgFilterHtwV2: 'ic_filter_htw',
  svgFilterMbs1V2: 'ic_filter_mbs1',
  svgFilterLiveV2: 'ic-fil-live-light-grey',
  svgFilterPercentV2: 'ic_filter_percent',
  svgFilterTvV2: 'ic-fil-tv-light-grey',
  svgFilterFavouriteV2: 'ic_filter_favourite_v2',
  svgFilterCollapseV2: 'ic-filter-collapse-v2',
  svgFilterRapidGamesV2: 'ic_filter_rapid_games',
  svgFilterXgV2: 'filter_xg',
  svgFilterFilterV2: 'ic_filter_filter',
  svgInfoCircleBorderedBlack: 'ic_info_circle_bordered_black',
  svgRankTribun: 'ic_rank_tribun',
  svgRankBadgeFirst: 'ic_rank_badge_first',
  svgRankBadgeSecond: 'ic_rank_badge_second',
  svgRankBadgeThird: 'ic_rank_badge_third',
  svgRankBadgeOther: 'ic_rank_badge_other',
  svgTribunRefresh: 'ic_tribun_refresh',
  svgTribunShareGreen: 'ic_tribun_share_green',
  svgForgotPassword: 'ic_forgot_password',
  svgForgotPasswordOtp: 'ic_forgot_password_otp',
  svgDatePickerGray: 'ic_date_picker',
  svgMail: 'ic_mail',
  svgPhoneNew: 'ic_phone_new',
  svgSystemPhone: 'ic_system_phone',
  svgSystemLaptop: 'ic_system_laptop',
  svgBilyonerLogo: 'ic_bilyoner_logo',
  svgWarningModal: 'ic_warning_modal',
  svgTribunShareModal: 'ic_tribun_share_modal',
  svgTribunEntryEdit: 'ic_tribun_coupon_entry_edit',
  svgInfoFilled: 'ic_info_filled',
  svgInfoNeutralFilled: 'ic_info_neutral_filled',
  svgShareBlackWhite: 'ic_share_black_white',
  svgBahistaShines: 'ic_bahista_shines',
  svgBahistaEyeOpen: 'ic_bahista_eye_open',
  svgBahistaProbabilitySurprise: 'ic_bahista_probability_surprise',
  svgBahistaProbabilityBalanced: 'ic_bahista_probability_balanced',
  svgBahistaProbabilityHigh: 'ic_bahista_probability_high',
};
